module.exports = __webpack_public_path__ + "img/profile-suggested.777174da.svg";